import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'
import { Card } from 'components'

export const TodayMeetings = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
`

export const TodayMeetingsHeader = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${measures.mobileThreshold}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const MeetingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const MeetingCard = styled(Card)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border: 1px solid ${colors.lightGrey};

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`

export const MeetingInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const ClientName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.darkGrey};
  margin-bottom: 4px;
`

export const MeetingDateTime = styled.span`
  font-size: 14px;
  color: ${colors.steelGrey};
`

export const MeetingActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const ActionButton = styled.button<{ variant?: 'missed' | 'validate' | 'cancel' }>`
  width: fit-content;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  ${(props) =>
    props.variant === 'missed' &&
    `
    background: ${colors.white};
    border-color: ${colors.reddishPink};
    color: ${colors.reddishPink};

    &:hover {
      background: ${colors.reddishPink};
      color: ${colors.white};
    }
  `}

  ${(props) =>
    props.variant === 'validate' &&
    `
    background: ${colors.lightGreen};
    border-color: ${colors.lightGreen};
    color: ${colors.white};

    &:hover {
      background: #6bb61a;
      border-color: #6bb61a;
    }
  `}
  ${(props) =>
    props.variant === 'cancel' &&
    `
      background: none;
      border: none;
      padding: 0;
      color: ${colors.darkGrey};
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const NoMeetingsMessage = styled(Card)`
  text-align: center;
  padding: 40px 20px;
  color: ${colors.steelGrey};
  font-style: italic;
`
